// SceneForm.form.js
import * as Yup from "yup";

export const categoryOptions = [
  { key: "01", text: "CIENCIAS HUMANAS", value: "CIENCIAS HUMANAS" },
  { key: "02", text: "CIENCIAS NATURALES", value: "CIENCIAS NATURALES" },
  { key: "03", text: "HISTORIA", value: "HISTORIA" },
  { key: "04", text: "MATEMÁTICAS", value: "MATEMÁTICAS" },
  { key: "05", text: "ARTE", value: "ARTE" },
  { key: "06", text: "VIDA SALUDABLE", value: "VIDA SALUDABLE" },
  { key: "07", text: "INGLÉS", value: "INGLÉS" },
  { key: "08", text: "EMPRENDIMIENTO", value: "EMPRENDIMIENTO" },
  { key: "09", text: "TECNOLOGÍA", value: "TECNOLOGÍA" },
  { key: "10", text: "ROBÓTICA", value: "ROBÓTICA" },
];

export const subcategoryOptions = [
  { key: "s01", text: "Antropología", value: "Antropología" },
  { key: "s02", text: "Arqueología", value: "Arqueología" },
  { key: "s03", text: "Ciencias Políticas", value: "Ciencias Políticas" },
  { key: "s05", text: "Filosofía", value: "Filosofía" },
  { key: "s06", text: "Geografía", value: "Geografía" },
  { key: "s07", text: "Gramática", value: "Gramática" },
  { key: "s08", text: "Idiomas", value: "Idiomas" },
  { key: "s09", text: "Psicología", value: "Psicología" },
  { key: "s10", text: "Sociedad", value: "Sociedad" },
  { key: "s11", text: "Astronomía", value: "Astronomía" },
  { key: "s12", text: "Biología", value: "Biología" },
  { key: "s13", text: "Botánica", value: "Botánica" },
  { key: "s14", text: "Geología", value: "Geología" },
  { key: "s15", text: "Química", value: "Química" },
  { key: "s16", text: "Prehistoria", value: "Prehistoria" },
  { key: "s17", text: "Edad Antigua", value: "Edad Antigua" },
  { key: "s18", text: "Edad Media", value: "Edad Media" },
  { key: "s19", text: "Edad Moderna", value: "Edad Moderna" },
  { key: "s20", text: "Edad Contemporánea", value: "Edad Contemporánea" },
  { key: "s21", text: "Lógica y fundamentos", value: "Lógica y fundamentos" },
  { key: "s22", text: "Aritmética", value: "Aritmética" },
  { key: "s23", text: "Álgebra", value: "Álgebra" },
  { key: "s24", text: "Geometría", value: "Geometría" },
  { key: "s25", text: "Matemáticas discretas", value: "Matemáticas discretas" },
  { key: "s26", text: "Matemáticas aplicadas", value: "Matemáticas aplicadas" },
  { key: "s27", text: "Arquitectura", value: "Arquitectura" },
  { key: "s28", text: "Cine", value: "Cine" },
  { key: "s29", text: "Artes Escénicas", value: "Artes Escénicas" },
  { key: "s30", text: "Escultura", value: "Escultura" },
  { key: "s31", text: "Literatura", value: "Literatura" },
  { key: "s32", text: "Pintura", value: "Pintura" },
  { key: "s33", text: "Artes aplicadas", value: "Artes aplicadas" },
  {
    key: "s34",
    text: "Alimentación y Nutrición",
    value: "Alimentación y Nutrición",
  },
  { key: "s35", text: "Higiene", value: "Higiene" },
  {
    key: "s36",
    text: "Actividad Física y Deporte",
    value: "Actividad Física y Deporte",
  },
  {
    key: "s37",
    text: "Bienestar, Salud Emocional y Convivencia",
    value: "Bienestar, Salud Emocional y Convivencia",
  },
  { key: "s38", text: "Entorno Sostenible", value: "Entorno Sostenible" },
  {
    key: "s39",
    text: "Seguridad y Prevención de Riesgos",
    value: "Seguridad y Prevención de Riesgos",
  },
  {
    key: "s40",
    text: "Educación afectivo sexual",
    value: "Educación afectivo sexual",
  },
  {
    key: "s41",
    text: "Prevención de dependencias",
    value: "Prevención de dependencias",
  },
  { key: "s42", text: "Física y Tecnología", value: "Física y Tecnología" },
  {
    key: "s43",
    text: "Tecnología de la Información y Comunicación",
    value: "Tecnología de la Información y Comunicación",
  },
  { key: "s44", text: "Educación", value: "Educación" },
  { key: "s45", text: "Otros", value: "Otros" },
];

export function initialValuesOne(scene) {
  return {
    ModOneTitle: scene?.ModOneTitle || "",
    ModOneCategory: scene?.ModOneCategory || [],
    ModOneSubcategory: scene?.ModOneSubcategory || [],
    ModOneTags: scene?.ModOneTags || [],
    tagsInput: "",
    ModOneDescription: scene?.ModOneDescription || "",
    bannertop: scene?.bannertop || null,
    ModOneUrlsala: scene?.ModOneUrlsala || "",
    // Añadimos idScene para que StepOne siempre lo tenga disponible
    idScene: scene?.refId || localStorage.getItem("idScene") || "",
  };
}

export function validationSchemaOne() {
  return Yup.object({
    ModOneTitle: Yup.string().required("El título es obligatorio"),
    ModOneCategory: Yup.array()
      .min(1, "Selecciona al menos una categoría")
      .required("La categoría es obligatoria"),
    ModOneSubcategory: Yup.array()
      .min(1, "Selecciona al menos una subcategoría")
      .required("La subcategoría es obligatoria"),
    ModOneTags: Yup.array()
      .min(1, "Ingresa al menos una etiqueta")
      .required("Las etiquetas son obligatorias"),
    ModOneDescription: Yup.string().required("La descripción es obligatoria"),
    bannertop: Yup.string().required("El banner top es obligatorio"),
    ModOneUrlsala: Yup.string()
      .url("Ingresa una URL válida")
      .required("La URL es obligatoria"),
    // Validamos también idScene para asegurar que existe
    idScene: Yup.string().required(),
  });
}
